<script>
import appConfig from "@/app.config";
import LocalInvoiceComponent from "@/router/views/local-invoices/LocalInvoiceComponent"
import Layout from "../../layouts/main";


export default {
  page: {
    title: "Facture",
    meta: [{ name: "description", content: appConfig.description }]
  },

  components: { Layout,LocalInvoiceComponent },

  props:{ 
    localInvoiceId:{
      type:Number,
      default:0
    },

    showTransfer:{
      type: Boolean,
      default:null
    }
  }

}

</script>

<template>
  <Layout>
     <LocalInvoiceComponent :localInvoiceId=this.localInvoiceId :showTransfer=this.showTransfer />
  </Layout>
</template>